import { ProductsListProps } from './products-list.types';

export const ProductsListPresets: Partial<ProductsListProps> = {
  products: [],
};
